import moment from 'moment/moment';

export const customersTableColumns = [
  {
    title: 'name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'phone_number',
    dataIndex: 'phone_number',
    key: 'phone_number',
  },
  {
    title: 'email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'customer_type',
    dataIndex: 'type',
    key: 'type',
    render: (text) => (text === 'physical' ? 'physical' : 'legal'),
  },
  {
    title: 'reset_password',
    dataIndex: 'reset_password',
    key: 'reset_password',
  },
  {
    title: 'edit',
    dataIndex: 'edit',
    key: 'edit',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];

export const physicalCustomerColumns = [
  {
    title: 'first_name',
    dataIndex: 'first_name',
    key: 'first_name',
  },
  {
    title: 'last_name',
    dataIndex: 'last_name',
    key: 'last_name',
  },
  {
    title: 'gender',
    dataIndex: 'gender',
    key: 'gender',
    render: (gender, { genders }) => genders?.find((g) => g.value === gender)?.label_ka,
  },
  {
    title: 'citizenship',
    dataIndex: 'citizenship',
    key: 'citizenship',
    render: (citizenship, { countries }) => countries?.find(
      (c) => c.id === citizenship,
    )?.name_ka,
  },
  {
    title: 'personal_number',
    dataIndex: 'personal_number',
    key: 'personal_number',
  },
  {
    title: 'passport_number',
    dataIndex: 'passport_number',
    key: 'passport_number',
  },
  {
    title: 'country_phone_code',
    dataIndex: 'country_phone_code',
    key: 'country_phone_code',
  },
  {
    title: 'edit',
    dataIndex: 'edit',
    key: 'edit',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];

export const legalCustomerColumns = [
  {
    title: 'country',
    dataIndex: 'country',
    key: 'country',
    render: (country, { countries }) => countries?.find(
      (c) => c.id === country,
    )?.name_ka,
  },
  {
    title: 'identification_number',
    dataIndex: 'identification_number',
    key: 'identification_number',
  },
  {
    title: 'organization_type',
    dataIndex: 'organization_type',
    key: 'organization_type',
    render: (type, { organizationTypes }) => organizationTypes?.find(
      (ot) => ot.id === type,
    )?.name_ka,
  },
  {
    title: 'organization_name',
    dataIndex: 'organization_name',
    key: 'organization_name',
  },
  {
    title: 'bank_account_number',
    dataIndex: 'bank_account_number',
    key: 'bank_account_number',
  },
  {
    title: 'legal_address',
    dataIndex: 'legal_address',
    key: 'legal_address',
  },
  {
    title: 'edit',
    dataIndex: 'edit',
    key: 'edit',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];

export const paymentColumns = [
  {
    title: 'payment_date',
    dataIndex: 'payment_date',
    key: 'payment_date',
  },
  {
    title: 'customer_email',
    dataIndex: 'customer_email',
    key: 'customer_email',
  },
  {
    title: 'Approval Code',
    dataIndex: 'approval_code',
    key: 'approval_code',
  },
  {
    title: 'bank_code',
    dataIndex: 'payment_id',
    key: 'payment_id',
  },
  {
    title: 'amount',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'returned_amount',
    dataIndex: 'refunded_amount',
    key: 'refunded_amount',
  },
  {
    title: 'statement_core_id',
    dataIndex: 'statement_id',
    key: 'statement_id',
  },
  {
    title: 'details',
    dataIndex: 'details',
    key: 'details',
  },

];

export const adminUserColumns = [
  {
    title: 'username',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: 'role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'edit',
    dataIndex: 'edit',
    key: 'edit',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];

export const paymentLogColumns = [
  {
    title: 'date_time',
    dataIndex: 'date',
    key: 'date',
    render: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss:SSS'),
  },
  {
    title: 'status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'sent_data',
    dataIndex: 'request',
    key: 'request',
  },
  {
    title: 'received_data',
    dataIndex: 'response',
    key: 'response',
  },
];
